import { Link } from "react-router-dom";
import type { NewsArticle } from "@/types/news";
import { formatViews, getCategoryName, newsTypeLabels, relativeTime } from "@/utils/news";

const typeBadge: Record<string, { icon: string; cls: string }> = {
  video: { icon: "ri-play-fill", cls: "bg-accent-500 text-background-50" },
  image: { icon: "ri-image-2-fill", cls: "bg-primary-600 text-background-50" },
};

export default function NewsCard({ article }: { article: NewsArticle }) {
  const badge = typeBadge[article.type];

  return (
    <Link
      to={`/detail/${article.id}`}
      className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-all hover:border-primary-300 hover:bg-background-100"
    >
      <div className="relative h-24 w-36 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-28 md:w-44">
        <img
          src={article.cover}
          alt={article.title}
          title={`${article.title} - 51爆料网`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        {badge && (
          <span
            className={`absolute left-2 top-2 flex h-6 w-6 items-center justify-center rounded-md ${badge.cls}`}
          >
            <i className={`${badge.icon} text-xs`} />
          </span>
        )}
      </div>

      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex flex-wrap items-center gap-2 text-xs">
          <span className="rounded bg-primary-100 px-2 py-0.5 font-medium text-primary-700">
            {getCategoryName(article.category)}
          </span>
          <span className="rounded bg-secondary-100 px-2 py-0.5 text-secondary-700">
            {article.region}
          </span>
          <span className="text-foreground-400">{newsTypeLabels[article.type]}</span>
        </div>

        <h3 className="news-clamp-2 mt-2 text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
          {article.title}
        </h3>

        <p className="news-clamp-2 mt-1.5 hidden text-sm leading-relaxed text-foreground-500 md:block">
          {article.summary}
        </p>

        <div className="mt-auto flex flex-wrap items-center gap-x-4 gap-y-1 pt-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-time-line" />
            {relativeTime(article.publishTime)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" />
            {formatViews(article.views)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-chat-3-line" />
            {article.comments}
          </span>
        </div>
      </div>
    </Link>
  );
}